import { connect } from 'react-redux'
import Zone from './Zone.jsx'
import {
    computeViewData,
    getScale,
} from '../../../../../redux/canvas/selectors'
import { selectCollaborativeIndexationZone } from '../../../../../redux/collaborativeIndexations/actions'
import {
    isCollaborativeIndexationSelected,
    isCollaborativeIndexationCreationOpened,
} from '../../../../../redux/collaborativeIndexations/selectors'
import { isPrintPreviewOpened } from '../../../../../redux/print/selectors'

const mapStateToProps = (state, props) => ({
    computeViewData: () => computeViewData(state, props.parentId),
    scale: getScale(state, props.parentId),
    isCollaborativeIndexationSelected: uuid => props.selected || isCollaborativeIndexationSelected(state, uuid),
    isSelectable: ! isPrintPreviewOpened(state) && ! isCollaborativeIndexationCreationOpened(state),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    selectCollaborativeIndexationZone: () => dispatch(selectCollaborativeIndexationZone(ownProps.zone)),
})

export const ZoneContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Zone)
